import React, { useEffect } from 'react';
import './Siemens.css';
import usePageTitle from '../hooks/usePageTitle';
import borderImage from '../assets/border.png';
import paper1 from '../assets/paper1.png';
import paper2 from '../assets/paper2.png';

const Siemens: React.FC = () => {
  usePageTitle('Siemens');
  
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Remove animation classes first to reset
    const allElements = document.querySelectorAll('.siemens-title, .siemens-subtitle, .siemens-description, .siemens-paragraph');
    allElements.forEach(element => {
      element.classList.remove('animate-in-initial');
    });
    
    // Force reflow to ensure the removal is processed
    void document.body.offsetHeight;
    
    // Animate initial content on page load
    const titleElement = document.querySelector('.siemens-title');
    if (titleElement) {
      setTimeout(() => {
        titleElement.classList.add('animate-in-initial');
      }, 200);
    }
    
    // Subtitle animates after title
    const subtitleElements = document.querySelectorAll('.siemens-subtitle');
    setTimeout(() => {
      subtitleElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 210);
    
    // Paragraphs animate 200ms after subtitle
    const paragraphElements = document.querySelectorAll('.siemens-description, .siemens-paragraph');
    setTimeout(() => {
      paragraphElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 410);
  }, []);

  return (
    <div className="siemens-page">
      <div className="siemens-container">
        <h1 className="siemens-title">Siemens Competition Regional Finalist</h1>
        <h2 className="siemens-subtitle">Lead-Free Perovskite Photovoltaics Research</h2>
        <img src={borderImage} alt="" className="siemens-border-image" />
        
        <div className="siemens-content">
          <div className="siemens-images-section">
            <div className="siemens-images-container">
              <img src={paper1} alt="Research Paper Page 1" className="siemens-image siemens-image-left" />
              <img src={paper2} alt="Research Paper Page 2" className="siemens-image siemens-image-right" />
            </div>
          </div>
          
          <div className="siemens-decorative-line"></div>
          
          <div className="siemens-text-section">
            <div className="siemens-text-container">
              <p className="siemens-description">
                University-level computational materials science research advancing to regional finals in America's most 
                prestigious high school STEM competition. Utilizing density functional theory calculations and sophisticated 
                modeling software to identify breakthrough lead-free materials for renewable energy applications. This caliber of 
                independent research—typically conducted by graduate students—demonstrates the intellectual rigor and 
                scientific capability that distinguishes exceptional candidates at elite universities, exemplifying the innovative 
                thinking admissions committees seek in competitive applicants.
              </p>
              
              <p className="siemens-paragraph">
                Materials Science & Engineering; Physics | Admission to Harvard
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Siemens;